import { ChartDataSets } from 'chart.js';

export const LineChartOptions: ChartDataSets = {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    lineTension: 0.1,
    pointRadius: 5,
    pointHitRadius: 15,
    pointHoverRadius: 5
};
